import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalDataService } from 'src/app/services/global/modal-data.service';
import { AreYouSureComponent } from '../../are-you-sure/are-you-sure.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';

export type Language = { id: number; name: string, native_name: string }

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit, OnDestroy {
  @Input() selectedLanguage: Language | null = null
  isSubmited: boolean = false;
  languageSkills: number[] = [3, 3, 3, 3];
  charCounter: any = {
    skillDescription: 0,
    languageSkillCounter: 0
  }
  getData: any;
  languageSkillInfoForm = this.formBuilder.group({
    name: new UntypedFormControl(this.data.name, [Validators.required]),
    reading_score: new UntypedFormControl(this.data.reading_score ? this.data.reading_score : 3, [Validators.required]),
    listening_score: new UntypedFormControl(this.data.listening_score ? this.data.listening_score : 3, [Validators.required]),
    writing_score: new UntypedFormControl(this.data.writing_score ? this.data.writing_score : 3, [Validators.required]),
    speaking_score: new UntypedFormControl(this.data.speaking_score ? this.data.speaking_score : 3, [Validators.required]),
    language_id: new UntypedFormControl(this.data.language_id),
    // description:new UntypedFormControl(this.data.description),
    // is_public: new UntypedFormControl(true),
  });
  errorObject: { text: string, type: string } = <{ text: string, type: string }>{}
  languageSkillInfoEmitter = new EventEmitter<any>();
  formValidator: any = {}
  is_public = new FormControl(this.data.is_public != null ? this.data.is_public : true)
  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public modalService: ModalDataService,
    public dialogSure: MatDialogRef<AreYouSureComponent>,
    private deviceDetector: DeviceDetectorService,
    private toasterService: ToastrService
  ) { }
  ngOnInit(): void {
    this.modalService.waiting = false;
    this.initData()
  }
  initData() {
    this.getData = this.data
    if (this.getData.action == 'edit')
      this.updateLanguage(this.getData.name)
  }
  getCurrentCharacter(e: Event, input: string) {
    this.charCounter[input] = (<HTMLInputElement>e.target).value.length
  }
  isMobile() {
    return this.deviceDetector.isMobile()
  }
  updataIsPublic(e: any): void {
    this.is_public.setValue(e)
  }
  readingSkillUpdate(e: any, order: number) {
    this.languageSkills[order] = e;
    this.languageSkillInfoForm.value.reading_score = this.languageSkills[0]
    this.languageSkillInfoForm.value.writing_score = this.languageSkills[1]
    this.languageSkillInfoForm.value.listening_score = this.languageSkills[2]
    this.languageSkillInfoForm.value.speaking_score = this.languageSkills[3]
  }
  sendRate(data: any, i: any) {
    if (i == 0) return data.reading_score ? data.reading_score : 5
    if (i == 1) return data.writing_score ? data.writing_score : 5
    if (i == 2) return data.listening_score ? data.listening_score : 5
    if (i == 3) return data.speaking_score ? data.speaking_score : 5
  }
  formSubmit(e: Event) {
    this.isSubmited = true;
    e.preventDefault();
    if (this.languageSkillInfoForm.valid && this.selectedLanguage) {
      for (let i = 0; i < 4; i++) {
        this.readingSkillUpdate(this.languageSkills[i], i)
      }
      this.errorObject = <{ text: string, type: string }>{}
      this.modalService.waiting = true;
      let formData = new FormData();
      formData.append('id', this.getData.id.toString())
      formData.append('additional_data', JSON.stringify({
        ...this.languageSkillInfoForm.value,
        language_id: this.selectedLanguage.id,
      }))
      formData.append('is_public', this.is_public.value)
      this.languageSkillInfoEmitter.emit(formData)
    } else {
      this.toasterService.error('', 'موارد را به درستی وارد کنید')
      this.modalService.waiting = false;
      this.errorObject = <{ text: string, type: string }>{}
      Object.keys(this.languageSkillInfoForm.controls).forEach((field: string) => {
        const control = this.languageSkillInfoForm.get(field);
        control?.markAsTouched({ onlySelf: true });
        this.formValidator[field as keyof any] = control?.status
      });
    }
  }
  closePostState(e: Event) {
    e.preventDefault();
    let form = this.languageSkillInfoForm.value;
    const is_change = this.modalService.isChangeFormValue(form, this.getData);
    if (is_change) {
      this.dialogSure.close()
      this.modalService.waiting = false;
    } else {
      this.dialogRef.open(AreYouSureComponent, {
        disableClose: true,
        data: {
          parentId: 'language-info-modal',
        }
      });
    }
  }
  updateLanguage(e: any) {
    this.selectedLanguage = e;
    this.languageSkillInfoForm.controls['name'].setValue(e?.name)
  }
  ngOnDestroy() {
    this.modalService.waiting = false;
  }
}
